import React from 'react';

import Button from 'components/ui_elements/Button';
import successIcon from 'assets/img/success-complaint.svg';
import failedIcon from 'assets/img/subtract.png';

import './message.scss';
import Translation from 'services/translation.service';

function Message(props) {
  const message = props.message ? props.message : null;

  const btnLabel = props.btnLabel
    ? props.btnLabel
    : props.success
    ? Translation.key('generic_btn_value_done')
    : Translation.key('generic_error_btn_try_again');

  const iconSrc = props.success ? successIcon : failedIcon;

  const classes = ['step-done-box'];
  if (props.classes) {
    classes.push(props.classes);
  }
  
  // Extract ticket number from message if present
  const extractTicketNumber = (htmlMessage) => {
    if (!htmlMessage) return null;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlMessage;
    const boldElement = tempDiv.querySelector('.bold');
    return boldElement ? boldElement.textContent.trim() : null;
  };

  const ticketNumber = extractTicketNumber(message);

  let msgbody = null;
  if (props.msgType && props.msgType === 'commitment') {
    msgbody = (
      <div className="msgcommitment">
        <div dangerouslySetInnerHTML={{ __html: message }} />
      </div>
    );
  } else {
    msgbody = (
      <div className="message-txt">
        <div dangerouslySetInnerHTML={{ __html: message }} />
      </div>
    );
  }

  return (
    <div className={classes.join(' ')}>
      <div className="done-step">
        {props.showIcon ? (
          <img className="message-icon" alt="check" src={iconSrc} />
        ) : null}
        
        <div className="message-content">
          {props.title && <div className="message-title">{props.title}</div>}
          
          {props.success && ticketNumber ? (
            <>
              <div className="message-description">
                {Translation.key('web_form_success_msg')}
              </div>
              <div className="ticket-number-box">
                <span className="ticket-label">Ticket No :</span>
                <span className="ticket-value">{ticketNumber}</span>
              </div>
            </>
          ) : (
            msgbody
          )}
        </div>

        <div className="message-btns-zone">
          {props.action && (
            <Button type="primary" label={btnLabel} action={props.action} />
          )}

          {props.cancelAction && (
            <Button
              type="secondary"
              label={props.cancelActionBtnLabel}
              action={props.cancelAction}
              className={props.newDesign ? 'newDesignSecondaryBtn' : ''}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Message;
Message.defaultProps = {
  showIcon: true,
};
